module.exports = __webpack_public_path__ + "media/images/ashtonemail-5381218e1a007219538cb76ad7604621.png";